<template>
  <div class="touchList" id="touchList">
    <head-top
      :appName="appName"
      :attention="attention"
      :bg="topicInfo.imgUrl"
      :sid="sid"
      :themeColor="themeColor"
      :topicID="topicID"
      :topicInfo="topicInfo"
      :uid="uid"
      @topicToApp="topicToApp"
      :shareData = "shareData"
    ></head-top>
    <list :sid="sid" :themeColor="themeColor" :topicID="topicID" @showPopover="showPopover"
          @topicShowSwiper="topicShowSwiper"></list>
    <bottomOpenApp :sid="sid" :themeColor="themeColor" @topicToApp="topicToApp"></bottomOpenApp>
    <Popover :appName="appName" @showPopover="showPopover" @topicToApp="topicToApp" v-if="popoverShow == 0"
             :istopiclist="1"></Popover>
  </div>
</template>
<script>
  import headTop from '../components/topic/head'
  import list from '../components/topic/list'
  import BottomOpenApp from '../components/BottomOpenApp.vue'
  import Popover from '../components/Popover'

  import wxShareTool from '../tool/wxShare'
  import utils from '../tool/utils'
  // import $ from 'jquery';

  export default {
    props: ['topicInfo', 'topicID', 'sid', 'uid', 'bg', 'attention', 'themeColor', 'appName'],
    data () {
      return {
        popoverShow: 1,
        discussID: '',
        shareData: {}
      }
    },
    created () {
      const _this = this
      utils.evokeAppInit(_this.sid, _this.topicID, _this.discussID, (/^(0|1|2)$/.test(this.$route.query.topicDetailType) ? this.$route.query.topicDetailType + '' : '2'), _this.$route.query.cid || 0)
    },
    mounted () {
      this.discussID = this.$route.params.discussID
      var _this = this
      if (Object.keys(_this.topicInfo).length > 0 && _this.sid) {
        wxShareTool.wxShare({
          sid: _this.sid,
          title: _this.topicInfo.title, // 分享标题
          desc: _this.topicInfo.description, // 分享描述
          // link: params.url, // 分享链接
          imgUrl: _this.topicInfo.shareImg || _this.topicInfo.imgUrl // 分享图标
        })
      }
      let _shareData = {
        ti: document.title || '',
        aid: _this.$route.params.discussID || _this.$route.params.topicID,
        ty: _this.$route.params.discussID ? '105' : '104',
        id: _this.$route.params.discussID || _this.$route.params.topicID,
        sid: _this.$route.params.sid
      }
      if (!_this.discussID) {
        _shareData.topicDetailType = (/^(0|1|2)$/.test(this.$route.query.topicDetailType) ? this.$route.query.topicDetailType + '' : '2')
      }
      if (_this.$route.query.cid) {
        _shareData.cid = _this.$route.query.cid || 0
      }
      _this.shareData = _shareData
      utils.wxLaunchChange('#btnOpenAppBanner', _this.topicToApp, '', 1, '', _shareData)
      utils.wxLaunchChange('.top-banner', _this.topicToApp, '', 1, '', _shareData)
      // utils.wxLaunchChange('.previous-topics-main', _this.topicToApp, '', 1, '', _shareData)
    },
    watch: {
      appName (newValue, oldValue) {
        this.appName = newValue
      },
      topicInfo (newValue, oldValue) {
        this.topicInfo = newValue
        var _this = this
        if (Object.keys(_this.topicInfo).length > 0 && _this.sid) {
          wxShareTool.wxShare({
            sid: _this.sid,
            title: _this.topicInfo.title, // 分享标题
            desc: _this.topicInfo.description, // 分享描述
            // link: params.url, // 分享链接
            imgUrl: _this.topicInfo.shareImg || _this.topicInfo.imgUrl // 分享图标
          })
        }
      }
    },
    methods: {
      topicToApp: function (e) {
        this.$emit('downApp')
      },
      topicShowSwiper: function (list, index) {
        this.$emit('showSwiper', list, index)
      },
      showPopover: function (n) {
        this.popoverShow = n || 0
      }
    },
    components: {
      headTop,
      list,
      BottomOpenApp,
      Popover
    }
  }
</script>

<style>
  .touchList {
    -webkit-overflow-scrolling: touch;
  }
  .touchList .more_two.content img{
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// topicColumn.vue?775c7a8f